// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rightPanel-background[data-v-1e488bfb] {
  position: fixed;
  top: 0;
  left: 0;
  opacity: 0;
  transition: opacity 0.3s cubic-bezier(0.7, 0.3, 0.1, 1);
  background: rgba(0, 0, 0, 0.2);
  z-index: -1;
}
.rightPanel[data-v-1e488bfb] {
  width: 100%;
  max-width: 260px;
  height: 100vh;
  position: fixed;
  top: 0;
  right: 0;
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.05);
  transition: all 0.25s cubic-bezier(0.7, 0.3, 0.1, 1);
  transform: translate(100%);
  background: #fff;
  z-index: 40000;
}
.show[data-v-1e488bfb] {
  transition: all 0.3s cubic-bezier(0.7, 0.3, 0.1, 1);
}
.show .rightPanel-background[data-v-1e488bfb] {
  z-index: 20000;
  opacity: 1;
  width: 100%;
  height: 100%;
}
.show .rightPanel[data-v-1e488bfb] {
  transform: translate(0);
}
.handle-button[data-v-1e488bfb] {
  width: 48px;
  height: 48px;
  position: absolute;
  left: -48px;
  text-align: center;
  font-size: 24px;
  border-radius: 6px 0 0 6px !important;
  z-index: 0;
  pointer-events: auto;
  cursor: pointer;
  color: #fff;
  line-height: 48px;
}
.handle-button i[data-v-1e488bfb] {
  font-size: 24px;
  line-height: 48px;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
